exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".msg-bg[data-v-281aef6b]{background-color:rgba(108,117,125,0)}.msg[data-v-281aef6b]{border-radius:.5rem;background-color:#fff}.my-msg[data-v-281aef6b]{border-radius:.5rem;background-color:#b0fbd0;border:none}.break-row[data-v-281aef6b]{white-space:pre-wrap;word-wrap:break-word}", ""]);

// exports
